import styled from "styled-components/macro";

export const CfcDetailBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
  padding: 15px 16px;
  border-radius: 6px;
  background: ${({ theme }) => theme.blueDark};
  color: ${({ theme }) => theme.white};

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`;

export const CfcDetailBannerCopy = styled.div`
  min-width: 0;
  font-family: light;
  font-size: 18px;
  line-height: 26px;

  sup {
    font-size: 11px;
    line-height: 0;
  }
`;

export const CfcDetailBannerStrong = styled.div`
  font-family: bold;
`;

export const CfcDetailBannerOrderButton = styled.button`
  flex-shrink: 0;
  height: 38px;
  padding: 0 24px;
  border: 2px solid ${({ theme }) => theme.white};
  border-radius: 20px;
  background: transparent;
  color: ${({ theme }) => theme.white};
  cursor: pointer;
  font-family: bold;
  font-size: 18px;
  line-height: 20px;
  text-transform: uppercase;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
`;
